import React,{useState} from "react";
import {Card, CardActions, CardContent, CardMedia, CircularProgress, TextField} from "@mui/material";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {green} from "@mui/material/colors";
import ErrorMsg from "../msg/ErrorMsg";
import { Navigate } from 'react-router-dom';
import axios from "axios";
import config from '../Config';
const Login = ()=>{
    const [loading , setLoading] = useState(false);
    const [username , setusername] = useState("");
    const [password , setPassword] = useState("");
    const [errorMsg , setErrorMsg] = useState("");
    const [isLogin , setIsLogin] = useState(false);
    const handleLoginClick = () =>{
        if (username !== '' && password !== ''){
            setLoading(true);
            const data = {
                username: username,
                password: password,
            };
            axios.post("https://app.zhivay.com/api/login.php",data,{timeout:2000})
                .then(response => {
                    setLoading(false);
                    if (response.status === 200){
                        if (response.data.error === false) {
                            localStorage.setItem('token',response.data.token);
                            setIsLogin(true);
                        }
                        else
                            setErrorMsg(response.data.message);
                    }

                })
                .catch(error =>{
                    if ( error.message === "Network Error"){
                        setLoading(false);
                        setErrorMsg("خطا در ارتباط با سرور");
                    }else {
                        setErrorMsg("خطا ! با پشتیبانی تماس بگیرید");
                        setLoading(false);
                    }
                })
        }
        else
            setErrorMsg("نام کاربری یا رمز عبور نباید خالی باشد")
    }
    const handleUsernameChange = (event)=>{
        setusername(event.target.value);
    }
    const handlePasswordChange = (event) =>{
        setPassword(event.target.value);
    }
    const Redirect = ()=>{
        console.log("Ad")
        return (<Navigate replace to="/" />)
    }
    return(

        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center',height:"100vh"}}>
            {isLogin ? <Redirect/> : ''}
            {errorMsg !== '' ? <ErrorMsg message={errorMsg} openn={true} seterrormsg={setErrorMsg}/> : '' }
            <Card sx={{ maxWidth: 345 , margin:2,display:"flex",alignItems:"center",flexDirection:"column"}}>
                <CardMedia
                    component="img"
                    image="https://app.zhivay.com/logo.png"
                    alt="green iguana"
                    sx={{bgcolor:"#f1f1f1",borderRadius:"50%" , height:"100px",width:"100px",padding:"20px"}}
                />
                <CardContent>
                    <Typography gutterBottom variant="h7" component="div" sx={{textAlign:"center"}}>
                        سیستم حسابداری ژیوای
                    </Typography>
                    <TextField
                        autoComplete='off'
                        type='text'
                        fullWidth
                        label="نام کاربری"
                        size="small"
                        onChange={handleUsernameChange}
                        variant="outlined" sx={{
                        marginTop:2,
                        marginBottom:1,
                    }} />
                    <TextField
                        autoComplete='off'
                        type='password'
                        fullWidth
                        size="small"
                        label="رمز عبور"
                        onChange={handlePasswordChange}
                        variant="outlined" sx={{
                        marginTop:2,
                        marginBottom:1,
                    }} />
                </CardContent>
                <CardActions>
                    <div style={{position: 'relative'}}>
                        <Button
                            fullWidth
                            onClick={handleLoginClick}
                            disabled={loading}
                            variant="contained">ورود</Button>
                        {loading && (
                            <CircularProgress
                                size={24}
                                sx={{
                                    color: green[500],
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    marginTop: '-12px',
                                    marginLeft: '-12px',
                                }}
                            />
                        )}
                    </div>
                </CardActions>
            </Card>
        </div>

    )
}
export default Login
